export default {
  // #region首页
  main_collection_function: 'Collection function',
  main_menu_bar_management: 'Menu bar management',
  // #endregion

  // #region Header
  main_header_download_app: 'Download the App',
  main_header_recent_visit: 'Recent visits',
  main_header_placeholder: 'Search',
  main_header_IT_system: 'IT Systems',
  main_header_todo_center: 'ToDo Centre',
  main_header_message_remind: 'Message Alerts',
  main_header_change_SYS_password: 'Change password',
  main_header_log_out: 'Logging out',
  main_header_log_out_tip: 'Confirm logout',
  main_header_log_out_title: 'Sign out prompt',
  main_header_confirm: 'Confirm',
  main_header_cancel: 'Cancel',
  main_header_change_name: 'Name',
  main_header_change_Work_number: 'ZT number',
  main_header_old_password: 'Old password',
  main_header_old_password_placeholder: 'Please enter your initial password',
  main_header_new_password: 'New password',
  main_header_new_password_placeholder: 'Please enter new password',
  main_header_confirm_password: 'Confirm Password',
  main_header_confirm_password_placeholder: 'Please confirm your password',
  main_header_messageObj_prompt: 'Prompt',
  main_header_messageObj_length: 'The password length must be 8 to 16 characters',
  main_header_messageObj_three_condition:
    'It needs to include three or more of the following: uppercase letters, lowercase letters, numbers, and special symbols',
  main_header_messageObj_no_repeat:
    'Sequential or repeated numbers of three or more characters are not allowed (e.g., 345, 333)',
  main_header_messageObj_old_new_different: 'Old and new passwords cannot be the same',
  main_header_messageObj_twice_different: 'The password entered twice must be consistent',
  main_header_change_success: 'Modify successfully',
  main_header_refresh: 'Refresh',
  main_header_close: 'Close',
  main_header_close_all: 'Close all',
  main_header_close_addition: 'Close all else',
  main_header_close_right: 'Close all on the right side of the current page',
  main_header_close_left: 'Close all on the left side of the current page',
  // #endregion

  // #region 首页
  main_home_home_name: 'Home',
  main_home_todo_title: 'My to-do list',
  main_home_todo_more: 'More',
  main_home_todo_checkAll: 'Select all',
  main_home_todo_batchProcess: 'Batch processing',
  main_home_todo_complaint: 'Transfer',
  main_home_todo_approve: 'Approved',
  main_home_todo_reject: 'Reject',
  main_home_todo_toDealWith: 'Go to processing',
  main_home_todo_work_dealed: 'Congratulations, you have finished processing your work!',
  main_home_todo_no_data: 'No data available',
  main_home_todo_current_select: 'Currently selected',
  main_home_todo_data_num: 'Data',
  main_home_todo_all: 'All',
  main_home_todo_approve_tip: 'Is this data confirmed as approved',
  main_home_todo_approve_title: 'Approved',
  main_home_todo_confirm: 'Confirm',
  main_home_todo_cancel: 'Cancel',
  main_home_todo_approve_success: 'Approved!',
  main_home_todo_reject_title: 'Rejected',
  main_home_todo_reject_reason: 'Please fill in the reason for rejection',
  main_home_todo_reject_success: 'Rejection processed successfully!',
  main_home_quick_title: 'Shortcut entrance',
  main_home_quick_create: 'Create shortcut',
  main_home_quick_cancel_common: 'Cancel common',
  main_home_quick_set_common: 'Set as frequently used',
  main_home_quick_sort: 'Sort by',
  main_home_quick_recommend: 'Set as recommended app',
  main_home_quick_add_common: 'Add to frequently used',
  main_home_quick_no_data: 'No data available',
  main_home_quick_cancel_common_success: 'Cancel Popular Success!',
  main_home_quick_set_common_success: 'Set as common successful!',
  main_home_quick_recommend_success: 'Success in setting as a recommended application!',
  main_home_report_transhipment: 'Forwarding - Air Freight',
  main_home_report_no_data: 'No data available',
  main_home_report_clearance: 'Customs clearance information',
  main_home_report_risk_control: 'Customs - Risk Control',
  main_home_micro_loading: 'System loading in progress...',
  main_header_full_screen: 'Full screen',
  main_header_forced_refresh: 'Forced refresh',

  // #endregion

  // #region request tips
  main_request_tip_exist_environ: 'Environment does not exist',
  main_request_tip_login_expired: 'Login has expired, please login again',
  main_request_tip_no_legal: 'No permission, please contact the administrator',
  main_request_tip_server_error: 'Server side error, please contact administrator',
  main_request_504_error: 'Gateway timeout, please try again',
  main_request_tip_system_error: 'System error, please contact administrator',
  main_request_tip_timeout: 'Requirement timeout, please refresh and try again',
  main_request_copy_success: 'Copied successfully',
  main_requestt_tip_confirm: 'OK',
  main_request_tip_cancel: 'Cancel',
  main_request_tip_delete_success: 'Deleted successfully',
  // #endregion

  // #region 登录、忘记密码
  main_login_welcome_system: 'Welcome to the GOFO system',
  main_login_loading_failure: 'Environment failed to load, please refresh and try again',
  main_login_morning_greetings: 'Good morning',
  main_login_noon_greetings: 'Good afternoon',
  main_login_afternoon_greetings: 'Good afternoon',
  main_login_night_greetings: 'Good evening',
  main_login_account: 'Account number',
  main_login_placeholder_input: 'Please enter',
  main_login_password: 'Password',
  main_login_retrieve_password: 'Find your password',
  main_login_btn_text: 'Login',
  main_login_account_tip: 'Please enter your account number',
  main_login_password_tip: 'Please enter your password',
  main_login_accountMap_LDAP: 'Domain',
  main_login_accountMap_SYS: 'GOFO Systems',
  main_login_accountMap_CAS: 'Zongteng Intranet',
  main_login_account_error: 'Account password error',
  main_login_retrieve_back: 'Back',
  main_login_select_account: 'Select the account to be retrieved',
  main_login_select_way: 'Select recovery method',
  main_login_authentication: 'Identity verification',
  main_login_reset_password: 'Reset password',
  main_login_work_number: 'ZT number',
  main_login_work_number_tip: 'Please enter the work number to be recovered',
  main_login_customer_tip: 'You are resetting your password for',
  main_login_operation_tip: 'to reset your password',
  main_login_verification_code:
    'Click to get the verification code, an email will be sent to your email address',
  main_login_verification_code_tip: 'Please enter the verification code',
  main_login_send_verification_code: 'Send verification code',
  main_login_name: 'Name',
  main_login_new_password: 'New password',
  main_login_new_password_tip: 'Please enter a new password',
  main_login_new_password_again_tip: 'Enter new password again',
  main_login_next_step: 'Next step',
  main_login_save: 'Save',
  main_login_reset_password_succeeded: 'Password reset successful, please login again',
  main_login_work_number_input: 'Please enter your work number',
  main_login_six_verification_code6: 'Please enter the 6-digit verification code',
  main_login_mail: 'By email',
  main_login_unknown_way: 'Unknown authentication method',
  main_login_get_in: 'Please be patient as you enter the system',
  main_login_no_exist_page: 'You do not have permission or the page does not exist',
  main_login_no_exist_page_tip:
    'Please check if the path is correct or click on the button to go back to the home page, if you have any problems please contact the administrator',
  main_login_no_exist_back: 'Back to home',
  main_login_no_last_back: 'Back',
  main_login_link_not_exist: 'Link does not exist',
  main_login_privacy_agree: 'By continuing, you agree to our',
  main_login_privacy_title_1: 'Terms of Use',
  main_login_privacy_confirm: 'Confirmed and read',
  main_login_privacy_title_2: 'Privacy Policy',
  main_login_privacy_tip: 'Please read and agree to our terms before logging in',
  main_login_privacy_think_btn: 'Think again',
  main_login_privacy_agree_btn: 'Agree',
  main_login_privacy_with: 'with'
  // #endregion
}
